import { helpers } from './base'

export const ShowHideButton = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      border: '1px solid rgba(255, 255, 255, 0.50)',
    },
  },
})
